import clsx from 'clsx';
import {
  ANNOUNCEMENT_RECEIPT_STATUS_DESCRIPTION,
  AnnouncementReceiptStatus,
} from '@/app/enums/AnnouncementReceiptStatus';

type ReceiptStatusBadgeProps = {
  status: AnnouncementReceiptStatus;
};

const BADGE_CLASS_BY_STATUS: Record<AnnouncementReceiptStatus, string> = {
  [AnnouncementReceiptStatus.PENDING]: 'badge-light-warning',
  [AnnouncementReceiptStatus.SEEN]: 'badge-light-info',
  [AnnouncementReceiptStatus.ACKNOWLEDGED]: 'badge-light-success',
  [AnnouncementReceiptStatus.DISMISSED]: 'badge-light-secondary',
};

const ReceiptStatusBadge = ({ status }: ReceiptStatusBadgeProps) => (
  <span className={clsx('badge', BADGE_CLASS_BY_STATUS[status])}>
    {ANNOUNCEMENT_RECEIPT_STATUS_DESCRIPTION[status]}
  </span>
);

export default ReceiptStatusBadge;
